import ACTIONS from '@/libs/signalR/vuexStore/storeActions';
import { ConnectionStatus, RunStates } from '@/libs/signalR/vuexStore/store/state';
import { stateSplicer } from '../../helpers';

const mutations = {
  [ACTIONS.SIGNAL_R__SET_HUB_TOKEN]: (state, payload) => {
    state.hubToken = payload
  },
  [ACTIONS.SIGNAL_R__SET_RUN_STATE]: (state, payload) => {
    state.runState = payload;
  },
  [ACTIONS.SIGNAL_R__HANDLE_CONNECT_EVENT]: (state, payload) => {
    state.connectionStatus = payload.eventType
  },
  [ACTIONS.SIGNAL_R__HANDLE_CHANGE_EVENT]: (state, payload) => {
    // Client behaviour based on eventType
    /**
     * @eventType RunFinished - Clients actively disconnect from hub
     * @eventType RunEdit - Clients go into blocking mode - connection to hub is kept alive
     * @eventType RunStarted - Clients leave blocking mode - connection to hub is kept alive
     * @eventType RunConference - Clients stay in active mode - connection to hub is kept alive
     */
    switch (payload.eventType) {
      case RunStates.RunFinished:
        state.connectionStatus = ConnectionStatus.ClientDisconnected
        state.runState = payload.eventType;
        return;
      default:
        state.runState = payload.eventType;
    }
  },
  /**
   *
   * @param state
   * @param payload
   * @param { number } payload.clientId - ClientId
   * @param { number } payload.participantId - ParticipantId
   * @param { number } payload.exerciseId - ExerciseId
   * @param { number } payload.documentId - DocumentId
   * @param { "DocumentAdded" | "DocumentRemoved" | "DocumentsCleared" } payload.eventType - EventType
   */
  [ACTIONS.SIGNAL_R__HANDLE_DOCUMENT_CHANGE]: (state, payload) => {
    const { eventType } = payload;
    switch ( eventType ) {
      case 'DocumentAdded':
        state.exerciseDocuments = {
          ...state.exerciseDocuments,
          [payload.participantId]: {
            ...state.exerciseDocuments[payload.participantId],
            [payload.exerciseId]: state.exerciseDocuments[payload.participantId]?.[payload.exerciseId]
              ? [...new Set([...state.exerciseDocuments[payload.participantId][payload.exerciseId], payload.documentId])]
              : [payload.documentId]
          }
        }
        break;
      case 'DocumentRemoved':
        state.exerciseDocuments = {
          ...state.exerciseDocuments,
          [payload.participantId]: {
            ...state.exerciseDocuments[payload.participantId],
            [payload.exerciseId]: stateSplicer(
              state.exerciseDocuments[payload.participantId]?.[payload.exerciseId],
              state.exerciseDocuments[payload.participantId]?.[payload.exerciseId]?.findIndex((ex) => ex === payload.documentId)
            )
          }
        }
        break;
      case 'DocumentsCleared':
        // remove all documents for the exercise
        state.exerciseDocuments = {
          ...state.exerciseDocuments,
          [payload.participantId]: {
            ...state.exerciseDocuments[payload.participantId],
            [payload.exerciseId]: []
          }
        }
        break;
      default:
        break;
    }
  },
  /**
   *
   * @param state
   * @param payload
   * @param { number } payload.clientId - ClientId
   * @param { number } payload.participantId - ParticipantId
   * @param { number } payload.exerciseId - ExerciseId
   * @param { "ExerciseAdded" | "ExerciseRemoved" } payload.eventType - EventType
   */
  [ACTIONS.SIGNAL_R__HANDLE_EXERCISE_CHANGE]: (state, payload) => {
    const { eventType } = payload;
    if (!payload.exerciseId || !payload.participantId) return;
    switch (eventType) {
      // only one exercise can be assigned to each participant
      case 'ExerciseAdded':
        state.exercises = {
          ...state.exercises,
          [payload.participantId]: payload.exerciseId
        }
        break;
      case 'ExerciseRemoved':
        // also clear all associated documents if the exercise is removed
        state.exercises = {
          ...state.exercises,
          [payload.participantId]: undefined
        }
        state.exerciseDocuments = {
          ...state.exerciseDocuments,
          [payload.participantId]: {
            ...state.exerciseDocuments[payload.participantId],
            [payload.exerciseId]: []
          }
        }
        break;
      default:
        break;
    }
  },
}

export default mutations
